import { createDomain } from 'effector';

export const loginActionDomain = createDomain();
